export default __webpack_public_path__ + "static/coin_blue-8dcf5e7fdc1cf1f6bd18ab9aa3eba480.png";